import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { ScrollArea } from "@/components/ui/scroll-area";
import * as LucideIcons from "lucide-react";

const AVAILABLE_ICONS = [
  "coffee", "heart", "cake", "briefcase", "clock", "x-circle", "shirt",
  "star", "calendar", "utensils", "wine", "music", "sun", "moon",
  "users", "map-pin", "gift", "crown", "sparkles", "flame", "leaf",
  "globe", "phone", "mail", "camera", "image", "flag", "bookmark",
  "award", "zap", "shield", "bell", "home", "eye", "settings",
  "check", "info", "alert-triangle", "help-circle", "thumbs-up",
  "smile", "circle-check", "circle-x", "ban", "lamp", "soup",
  "salad", "sandwich", "pizza", "beer", "cigarette", "accessibility",
  "alarm-clock", "apple", "armchair", "baby", "badge-check",
  "badge-info", "banknote", "bath", "bed", "bike", "bone",
  "brain", "car", "cherry", "circle-dot", "clover", "compass",
  "cookie", "cross", "diamond", "dog", "door-open", "drama",
  "drum", "egg", "feather", "fish", "flower", "footprints",
  "glasses", "grape", "guitar", "hammer", "hand-heart",
];

function toIconComponent(name) {
  if (!name) return LucideIcons.Star;
  const pascal = name.split("-").map(s => s.charAt(0).toUpperCase() + s.slice(1)).join("");
  return LucideIcons[pascal] || LucideIcons.Star;
}

export default function IconPicker({ open, onOpenChange, value, onSelect }) {
  const [search, setSearch] = useState("");
  const filtered = AVAILABLE_ICONS.filter(n => n.includes(search.toLowerCase()));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-md">
        <DialogHeader>
          <DialogTitle>Seleccionar icono</DialogTitle>
        </DialogHeader>
        <Input
          data-testid="icon-search-input"
          placeholder="Buscar icono..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="bg-background border-border mb-3"
        />
        <ScrollArea className="h-64">
          <div className="grid grid-cols-6 gap-2">
            {filtered.map(name => {
              const Icon = toIconComponent(name);
              return (
                <button
                  key={name}
                  data-testid={`icon-option-${name}`}
                  className={`flex flex-col items-center gap-1 p-2 rounded-lg transition-all hover:bg-secondary ${value === name ? 'bg-primary/20 ring-1 ring-primary' : ''}`}
                  onClick={() => { onSelect(name); onOpenChange(false); }}
                >
                  <Icon className="w-5 h-5" />
                  <span className="text-[9px] text-muted-foreground truncate w-full text-center">{name}</span>
                </button>
              );
            })}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}

export function IconDisplay({ name, className }) {
  const Icon = toIconComponent(name);
  return <Icon className={className || "w-4 h-4"} />;
}
